import lightGreen from '@material-ui/core/colors/lightGreen'
import orange from '@material-ui/core/colors/orange'
import red from '@material-ui/core/colors/red'
import grey from '@material-ui/core/colors/grey'

export const styles = theme => ({
  highlightConfirmed: {
    backgroundColor: lightGreen['A100'],
  },

  highlightNoResponse: {
    backgroundColor: orange['A100'],
  },
  
  highlightNotPaid: {
    backgroundColor: red['A400'],
  },

  highlightBlacklist: {
    backgroundColor: grey['200'],
  }
})



// WEBPACK FOOTER //
// ./src/components/PassengerBookings/styles.js